export const RECEIVED_MARKETPLACE_SETTINGS = 'RECEIVED_MARKETPLACE_SETTINGS'
export const NO_MARKETPLACE_SETTINGS_FOUND = 'NO_MARKETPLACE_SETTINGS_FOUND'
export const UPDATED_MARKETPLACE_SETTINGS = 'UPDATED_MARKETPLACE_SETTINGS'
